<template>
    <div class="filter-body">

        Will be enabled soon
        <!-- <div class="form-group">
        <label for=""> Image Status</label>
        <div class="form-check" v-for="(filter,index) in imageStatusFilters">
            <label class="form-check-label"><input checked="" class="form-check-input" name="final_sent_status" type="radio" :value="filter.key" :checked="index === 0">{{filter.name}}</label>
        </div>
    </div> -->
        <!-- <div class="form-group">
        <label for=""> Outbound Status</label>
        <div class="form-check" v-for="(filter,index) in outboundStatusFilters">
            <label class="form-check-label"><input checked="" class="form-check-input" name="outbound_at" type="radio" :value="filter.key" :checked="index === 0">{{filter.name}}</label>
        </div>
    </div> -->
        <!-- <div class="form-group"><label for=""> Week Number</label>
        <input name="week_number[]" class="form-control" data-error="Invalid week format" placeholder="Enter Week" type="text">
    </div> -->
    </div>
</template>

<script>
export default {
  data: function () {
    return {
      finalSentStatus: [
        { name: 'All', key: '' },
        { name: 'Sent', key: 1 },
        { name: 'Not Sent', key: 0 }
      ],
      outboundStatusFilters: [
        { name: 'All', key: '' },
        { name: 'No', key: 'No' },
        { name: 'Yes', key: 'Yes' }
      ]
    }
  },
  mounted: function () {
    $('.select2').select2()
  }
}
</script>
